// extracted by mini-css-extract-plugin
export default {"ReplyButton":"pv_a bia_wx bia_jb bia_xl bia_i bia_j bia_q bia_vt bia_et bia_so bia_sp bia_eg","ReplyButton__icon":"pv_b bia_rz"};